var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 158,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3E3330",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.753 5.009h41.251c21.366 0 38.748 17.388 38.748 38.76 0 21.373-17.38 38.76-38.748 38.76H62.323c-2.89 0-3.066 1.34-3.066 2.027 0 1.01 0 2.983 3.066 2.983h22.679c24.127 0 43.755-19.635 43.755-43.77S109.129 0 85.002 0h-41.25C19.629 0 0 19.634 0 43.77v70.939a2.503 2.503 0 0 0 4.068 1.953L41.424 86.87a2.495 2.495 0 0 0 1.57-2.316 2.503 2.503 0 0 0-2.503-2.505h-.28c-.92 0-3.327 1.67-7.219 5.009L5.005 109.492V43.77c0-21.372 17.382-38.76 38.748-38.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.309 41.06c-1.465.63-1.547 1.703-1.547 2.71 0 .683.485 1.803 2.828 2.023 2.492.241 4.696.59 6.614 1.046 17.06 4.055 29.789 19.426 29.789 37.715v65.722l-27.41-21.97c-2.902-2.286-4.885-3.691-5.948-4.217-1.063-.525-2.458-.79-4.183-.792h-.912c-.097 0-.195.015-.293.015H92.996c-21.366 0-38.748-17.386-38.748-38.758 0-21.373 17.382-38.761 38.748-38.761 14.064-.147 21.73-.22 22.995-.22 1.899 0 2.752-1.122 2.752-1.804 0-1.006-.38-2.985-2.752-2.985H92.996c-24.127 0-43.755 19.635-43.755 43.77 0 24.132 19.628 43.766 43.755 43.766h41.251c.353 0 .709-.03 1.062-.04.05.003.092.025.143.025h2.128l36.352 29.144a2.486 2.486 0 0 0 2.648.303 2.501 2.501 0 0 0 1.42-2.256V84.554c.002-21.095-14.992-38.752-34.88-42.865-2.866-.593-6.346-1.26-7.811-.63z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateIcon);
export default __webpack_public_path__ + "static/media/activate-icon.61cf3d61277f3fc2b4302bed8fda36d9.svg";
export { ForwardRef as ReactComponent };